(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yf-language-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yf-language-selector')) {
    customElements.define('yf-language-selector', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.select = this.querySelector('select[name="language_code"]');
        if (!this.form || !this.select) return;
        this.onLanguageChange = () => this.form.requestSubmit();
        this.select.addEventListener('change', this.onLanguageChange);
        const submitButton = this.querySelector('button[type="submit"]');
        if (submitButton) submitButton.hidden = true;
      }

      disconnectedCallback() {
        this.select?.removeEventListener('change', this.onLanguageChange);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
